import { render } from "./studyHabits.vue?vue&type=template&id=31e1d036&scoped=true"
import script from "./studyHabits.vue?vue&type=script&lang=js"
export * from "./studyHabits.vue?vue&type=script&lang=js"

import "./studyHabits.vue?vue&type=style&index=0&id=31e1d036&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31e1d036"]])

export default __exports__